import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'common/css/master.css';
import './examPatternCreator.css';
import { getPatternSectionListSvc, getQusMarksSvc,getQusTypeListSvc,savePatternSectionSvc,approvePatternSvc,deletePatternSectionSvc ,deletePatternSvc } from './examPatternCreatorSvc';

function PatternSlider(props) {
    const { patternId, pattern: patternProp, patternDesc: patternDescProp, closeSlider, onSave, refreshPatternList } = props;

    const [loader, setLoader]                     = useState('none');
    const [pattern, setPattern]                   = useState('');
    const [patternDesc, setPatternDesc]           = useState('');
    const [lstSection, setLstSection]             = useState([]);
    const [currentPatternId, setCurrentPatternId] = useState(0);
    const [flgModal, setFlgModal]                 = useState(false);
    const [lstQusMarks, setLstQusMarks]           = useState([]);
    const [lstQusType, setLstQusType] = useState([]);
    const [editSectionIdx, setEditSectionIdx]     = useState(-1);

    const [newSection, setNewSection] = useState({
        qusMm: '',
        noOfQus: '',
        qusToAttempt: '',
        qusTypeId: '',
        complexityLevel: '',
        sectionDesc: '',
    });

    useEffect(() => {
        getQusMarksSvc((res) => {
            if (res.status === 'Success') {
                setLstQusMarks(res.lstQusMarks);
            }
        });

          getQusTypeListSvc((res) => {
        if (res.status === 'Success') setLstQusType(res.lstQusType);
    });
    }, []);

    useEffect(() => {
        setPattern(patternProp || '');
        setPatternDesc(patternDescProp || '');
        setLstSection([]);
        setCurrentPatternId(patternId || 0);
        if (patternId) {
            getPatternSectionListSvc(patternId, (res) => {
                if (res.status === 'Success') {
                    setLstSection(res.lstPatternSection);
                } else {
                    toast.error(res.message);
                }
            });
        }
    }, [patternId]);

    const savePattern = () => {
        if (!pattern.trim()) {
            toast.warn('Pattern name is required');
            return;
        }
        if (onSave) {
            const existingPatternId = currentPatternId;
            onSave(currentPatternId, pattern.trim(), patternDesc.trim(), (newPatternId) => {
                setCurrentPatternId(newPatternId || existingPatternId);
            });
        }
    };

    const saveSection = () => {
    if (!newSection.qusMm || !newSection.qusTypeId || !newSection.noOfQus) {
        toast.warn('Marks, Question Type and Total Questions are required');
        return;
    }
    if (newSection.qusToAttempt && parseInt(newSection.qusToAttempt) > parseInt(newSection.noOfQus)) {
        toast.warn('Questions to Attempt must be less than or equal to Total Questions');
        return;
    }
    const objPatternSection = {
        patternId:       currentPatternId,
        section:         String.fromCharCode(65 + (editSectionIdx >= 0 ? editSectionIdx : lstSection.length)),
        qusMm:           parseFloat(newSection.qusMm),
        noOfQus:         parseInt(newSection.noOfQus),
        qusToAttempt:    parseInt(newSection.qusToAttempt),
        sectionDesc:     newSection.sectionDesc,
        qusTypeId:       parseInt(newSection.qusTypeId),
        complexityLevel: parseInt(newSection.complexityLevel),
    };
    savePatternSectionSvc(objPatternSection, (res) => {
        if (res.status === 'Success') {
            toast.success(editSectionIdx >= 0 ? 'Section updated successfully' : 'Section added successfully');
            setFlgModal(false);
            getPatternSectionListSvc(currentPatternId, (r) => {
                if (r.status === 'Success') setLstSection(r.lstPatternSection);
            });
            if (refreshPatternList) refreshPatternList();
            setNewSection({ qusMm: '', noOfQus: '', qusToAttempt: '', qusTypeId: '', complexityLevel: '', sectionDesc: '' });
            setEditSectionIdx(-1);
        } else {
            toast.error(res.message);
        }
    });
};

const deleteSection = (section, idx) => {
    if (!window.confirm(`Are you sure you want to delete Section ${section}?`)) return;
    deletePatternSectionSvc(currentPatternId, section, (res) => {
        if (res.status === 'Success') {
            toast.success('Section deleted successfully');
            setLstSection(prev => prev.filter((_, i) => i !== idx));
            if (refreshPatternList) refreshPatternList();
        } else {
            toast.error(res.message);
        }
    });
};

const approvePattern = () => {
    if (!currentPatternId) {
        toast.warn('Save the pattern first.');
        return;
    }
    approvePatternSvc(currentPatternId, (res) => {
        if (res.status === 'Success') {
            toast.success(res.message);
            if (refreshPatternList) refreshPatternList();
        } else {
            toast.error(res.message);
        }
    });
};

    return (
        <>
            <form
                className="form form-horizontal"
                style={{
                    pointerEvents: loader === 'none' ? 'auto' : 'none',
                    height: 'auto',
                    width: 'auto',
                    margin: '10px',
                    background: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: 10,
                    paddingTop: 20,
                    paddingBottom: 20,
                }}
            >
                <button
                    type="button"
                    className="btn btn-info text-center btnCloseDiv"
                    onClick={closeSlider}
                >
                    <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
                </button>

                <div className="row" style={{ width: '100%' }}>
                    <div className="form-group col-md-6">
                        <h4 style={{ paddingLeft: 0, marginTop: 0, marginLeft:50,fontWeight: 'medium' }}>Pattern Details</h4>
                        <label className="control-label col-sm-5 text-right">Pattern<span className="red-color">*</span></label>
                        <div className="col-sm-6 padding-remove">
                            <input
                                type="text"
                                className="form-control"
                                value={pattern}
                                onChange={(e) => setPattern(e.target.value)}
                                placeholder="Enter pattern name"
                            />
                        </div>
                    </div>
                </div>

                <div className="row" style={{ width: '100%', display: 'flex', alignItems: 'flex-end' }}>
                    <div className="form-group col-md-6">
                        <label className="control-label col-sm-5 text-right">Description</label>
                        <div className="col-sm-6 padding-remove">
                            <textarea
                                className="form-control"
                                rows={3}
                                value={patternDesc}
                                onChange={(e) => setPatternDesc(e.target.value)}
                                placeholder="Enter description"
                            />
                        </div>
                    </div>
                    <div className="col-md-6 padding-remove" style={{ display: 'flex', alignItems: 'flex-end', gap: 8, paddingLeft: 0, paddingRight: 0 }}>
                        <button type="button" className="btn btn-info" onClick={savePattern}>Save</button>
                        {currentPatternId > 0 && (
                            <>
                                <button type="button" className="btn btn-success" onClick={approvePattern}>Approve</button>
                                <button type="button" className="btn btn-danger"
                                    onClick={() => {
                                        if (!window.confirm('Are you sure you want to delete this pattern?')) return;
                                        deletePatternSvc(currentPatternId, (res) => {
                                            if (res.status === 'Success') {
                                                toast.success('Pattern deleted successfully');
                                                if (refreshPatternList) refreshPatternList();
                                                closeSlider();
                                            } else {
                                                toast.error(res.message);
                                            }
                                        });
                                    }}>
                                    Delete
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </form>

            {currentPatternId > 0 && (
                <form
                    className="form form-horizontal"
                    style={{
                        minHeight: '50vh',
                        overflow: 'visible',
                        width: 'auto',
                        margin: '10px',
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: 10,
                    }}
                >
                    <div style={{ padding: '8px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                        <div style={{ display: 'flex', gap: 30, alignItems: 'baseline' }}>
                            <span style={{ fontSize: 14 }}><strong style={{ fontSize: 14 }}>No of Sections:</strong> {lstSection.length}</span>
                            <span style={{ fontSize: 14 }}><strong style={{ fontSize: 14 }}>Total Marks:</strong> {lstSection.reduce((sum, s) => sum + (parseFloat(s.qusMm) * parseInt(s.qusToAttempt) || 0), 0)}</span>
                        </div>
                        <span
                            title="Add Section"
                            className="addIcon glyphicon glyphicon-plus-sign"
                            onClick={() => setFlgModal(true)}
                        ></span>
                    </div>
                    <div style={{ padding: '0 20px' }}>
                        <table className="tableLayout1">
                            <colgroup>
                                <col width="8%" />
                                <col width="15%" />
                                <col width="18%" />
                                <col width="15%" />
                                <col width="15%" />
                                <col width="15%" />
                                <col width="14%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>Section</th>
                                    <th>Marks/Q</th>
                                    <th style={{ textAlign: 'left' }}>Question Type</th>
                                    <th style={{ textAlign: 'right' }}>Total Questions</th>
                                    <th style={{ textAlign: 'right' }}>To Attempt</th>
                                    <th>Difficulty</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                        <div className="tablebodyWrapper" style={{ height: 'auto', padding: '0 20px' }}>
                                <table className="tableLayout">
                                    <colgroup>
                                        <col width="8%" />
                                        <col width="15%" />
                                        <col width="18%" />
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="15%" />
                                        <col width="14%" />
                                    </colgroup>
                                    <tbody>
                                        {lstSection.length === 0 ? (
                                            <tr>
                                                <td colSpan={7} className="text-center">No sections found</td>
                                            </tr>
                                        ) : (
                                            lstSection.map((sec, idx) => (
                                                <tr key={idx}>
                                                    <td className="text-center">{String.fromCharCode(65 + idx)}</td>
                                                    <td className="text-center">{sec.qusMm}</td>
                                                    <td className="text-left">{sec.qusType}</td>
                                                    <td className="text-right">{sec.noOfQus}</td>
                                                    <td className="text-right">{sec.qusToAttempt}</td>
                                                    <td className="text-center">{{ 1: 'Easy', 2: 'Medium', 3: 'Hard' }[sec.complexityLevel] || sec.complexityLevel}</td>
                                                    <td className="text-center">
                                                        <span
                                                            className="glyphicon glyphicon-edit"
                                                            style={{ cursor: 'pointer', marginRight: 8 }}
                                                            onClick={() => {
                                                                setNewSection({
                                                                    qusMm: sec.qusMm,
                                                                    noOfQus: sec.noOfQus,
                                                                    qusToAttempt: sec.qusToAttempt,
                                                                    qusTypeId: sec.qusTypeId,
                                                                    complexityLevel: sec.complexityLevel,
                                                                    sectionDesc: sec.sectionDesc || '',
                                                                });
                                                                setEditSectionIdx(idx);
                                                                setFlgModal(true);
                                                            }}
                                                        />
                                                        <span
                                                            className="glyphicon glyphicon-trash"
                                                            style={{ cursor: 'pointer', color: '#c0392b' }}
                                                            onClick={() => deleteSection(String.fromCharCode(65 + idx), idx)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                </form>
            )}

            {flgModal && (
                <div className="modal-overlay" onClick={() => setFlgModal(false)}>
                    <div className="modal-content" style={{ padding: 40 }} onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="btn btn-info text-center" id="closeSlider"
                            onClick={() => setFlgModal(false)}
                            style={{ right: '-25px', top: '-25px', position: 'absolute', opacity: 1 }}>
                            <span className="glyphicon glyphicon-remove"></span>
                        </button>

                        <div className="form-group clearfix" style={{ marginBottom: 18, display: 'flex', alignItems: 'center' }}>
                            <label className="control-label col-sm-5 text-right" style={{ marginBottom: 0, paddingTop: 0, fontSize: 14 }}>Marks per Question</label>
                            <div className="col-sm-6 padding-remove">
                                <select className="form-control" style={{ width: '50%' }}
                                    value={newSection.qusMm}
                                    onChange={(e) => setNewSection({ ...newSection, qusMm: e.target.value })}>
                                    <option value="">Select</option>
                                    {lstQusMarks.map((mark, idx) => (
                                        <option key={idx} value={mark}>{mark}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="form-group clearfix" style={{ marginBottom: 18, display: 'flex', alignItems: 'center' }}>
                            <label className="control-label col-sm-5 text-right" style={{ marginBottom: 0, paddingTop: 0, fontSize: 14 }}>Question Type</label>
                            <div className="col-sm-6 padding-remove">
                                <select className="form-control"
                                    value={newSection.qusTypeId}
                                    onChange={(e) => setNewSection({ ...newSection, qusTypeId: e.target.value })}>
                                    <option value="">Select</option>
                                    {lstQusType.map((obj, idx) => (
                                        <option key={idx} value={obj.qusTypeId}>{obj.qusType}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="form-group clearfix" style={{ marginBottom: 18, display: 'flex', alignItems: 'center' }}>
                            <label className="control-label col-sm-5 text-right" style={{ marginBottom: 0, paddingTop: 0, fontSize: 14 }}>Total Questions</label>
                            <div className="col-sm-6 padding-remove">
                                <input type="number" className="form-control"
                                    value={newSection.noOfQus}
                                    onChange={(e) => setNewSection({ ...newSection, noOfQus: e.target.value })} />
                            </div>
                        </div>
                        <div className="form-group clearfix" style={{ marginBottom: 18, display: 'flex', alignItems: 'center' }}>
                            <label className="control-label col-sm-5 text-right" style={{ marginBottom: 0, paddingTop: 0, fontSize: 14 }}>To Attempt</label>
                            <div className="col-sm-6 padding-remove">
                                <input type="number" className="form-control"
                                    value={newSection.qusToAttempt}
                                    onChange={(e) => setNewSection({ ...newSection, qusToAttempt: e.target.value })} />
                            </div>
                        </div>
                        <div className="form-group clearfix" style={{ marginBottom: 18, display: 'flex', alignItems: 'center' }}>
                            <label className="control-label col-sm-5 text-right" style={{ marginBottom: 0, paddingTop: 0, fontSize: 14 }}>Difficulty</label>
                            <div className="col-sm-6 padding-remove">
                                <select className="form-control" style={{ width: '50%' }}
                                    value={newSection.complexityLevel}
                                    onChange={(e) => setNewSection({ ...newSection, complexityLevel: e.target.value })}>
                                    <option value="">Select</option>
                                                    <option value={1}>Easy</option>
                                    <option value={2}>Medium</option>
                                    <option value={3}>Difficult</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group clearfix" style={{ marginBottom: 18, display: 'flex', alignItems: 'center' }}>
                            <label className="control-label col-sm-5 text-right" style={{ marginBottom: 0, paddingTop: 0, fontSize: 14 }}>Description</label>
                            <div className="col-sm-6 padding-remove">
                                <textarea className="form-control" rows={3}
                                    value={newSection.sectionDesc}
                                    onChange={(e) => setNewSection({ ...newSection, sectionDesc: e.target.value })} />
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="col-sm-12 text-center" style={{ marginTop: 20 }}>
                                <button type="button" className="btn btn-info" onClick={saveSection}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default PatternSlider;
